'use client';

import { usePathname } from 'next/navigation';
import type { ReactNode } from 'react';

/** Se renderiza también en el HTML inicial y conserva el idioma al navegar con Next. */
export default function DocumentLanguage({ children, defaultLanguage }: {
  children: ReactNode;
  defaultLanguage: string;
}) {
  const pathname = usePathname();
  const language = pathname === '/en' || pathname?.startsWith('/en/') ? 'en'
    : pathname === '/pt' || pathname?.startsWith('/pt/') ? 'pt-BR' : defaultLanguage;
  return <html lang={language}>{children}</html>;
}
